import { Component, EventEmitter, Input, Output } from '@angular/core';

import { MySportProfileListItem, UserProvider } from '../../providers/user/user';

/**
 * Generated class for the MysportProfileListItemComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'mysport-profile-list-item',
  templateUrl: 'mysport-profile-list-item.html',
  styleUrls:['./mysport-profile-list-item.scss']
})
export class MysportProfileListItemComponent {


  @Input('showClose')
  showClose: boolean;
  @Input('profile')
  profile: MySportProfileListItem;
  @Output()
  remove: EventEmitter<number>;
  constructor(public userService: UserProvider) {
    this.remove = new EventEmitter<number>();
  }

  removeProfile() {
    console.log(this.profile.id);
    this.userService.removeFriend(this.profile.id).then((succ) => {
      if (succ) {
        this.remove.emit(this.profile.id);
      }
    })
  }
}
